// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getPromotionListForProfessional } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitPromotionListProfessionalApi = createAsyncThunk(
  "hitPromotionListProfessionalApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("professionalToken")}`,
        },
        params: payload,
      };
      const url = ApiBaseUrl + getPromotionListForProfessional;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const PromotionListProfessionalSlice = createSlice({
  name: "promotionListProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitPromotionListProfessionalData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitPromotionListProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitPromotionListProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitPromotionListProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitPromotionListProfessionalData } = PromotionListProfessionalSlice.actions;
export default PromotionListProfessionalSlice.reducer;
